import React, { useState } from "react";
import Chart from "react-google-charts";
import { Button } from "antd";
import * as tConst from "../Common/Constants";
import { createQuarterHeader, iterationHeader } from "./TimelineHeader";
import { PrepareTimelineDataAdoSimplified, TimelineDataResult } from "./data/PrepareTimelineData";
//import * as iterationTool from "./data/IterationUtil";
//import { TicketItem } from '../utils/PrepareTicket';
import { Ticket } from "../services/Ticket";
import { ProjectWorkItemData } from "../services/AzureDevOpsService";
import ChartMenu from "./ChartMenu/ChartMenu";
import ChartMenuMultiSelect from "./ChartMenu/ChartMenuMultiSelect";
import ChartSprintHeaderMenuAdo, { SelectedSprint } from "./ChartSprintHeaderMenu";
import { TelemetryService } from "../services/TelemetryService";

interface TimelineAdoProps {
  items: Ticket[];
  viewId: string; // Use BigInt or string based on your data type
  onSetRefresh: () => void;
  onUpdateTicket: (ticketId: number, updatedFields: Record<string, any>) => Promise<void>;
  setShowChartMenu: (show: boolean) => void;
  showChartMenu: boolean;
  quarterFilter: any;
  onMoveAndExtendIteration: (...args: any[]) => void;
  RemoveFromTimeline: (ticketId: number) => void;
  AddPlanningTask: (selectedTicket: Ticket, spec: string) => void;
  createTicket(project: string, ticketType: string, fields: Record<string, any>, parentUrl : string): Promise<any>;
  FindTicket: (ticketId: string) => Promise<any>;
  AddTicketToSprint: (ticketId: string, startDate: string, endDate: string) => Promise<any>;
  project: string;
  teamId: string;
  assigneeId: string;
  selectedPriorityDriver : string
  selectedTags: string[];
  selectedAreaPath?: string;
  showTeams: boolean; // Default to false if not provided
  useAdvancedMode: boolean; // New prop for advanced mode
  projectWorkItemData: ProjectWorkItemData[];
  usersData: any[];
  capexOptions: string[];
  govProjectOptions: string[];
  priorityDriverOptions: string[];
  demoOptions: string[];
  productOptions: string[];
  investmentClassOptions: string[];
  areaPathOptions?: string[]; // Add area path options (optional, only for RnD Planning)
  azureDevOpsService: any; // Add AzureDevOpsService instance
  iterationsData: any[]; // Add iterations data
  multiSelectMode: boolean;
  onMultiSelectChange?: (count: number, onEdit: () => void) => void;
}

const arraySetup: any[][] = [
  [
    { type: "string", id: "Term" },
    { type: "string", id: "Name" },
    { type: "string", role: "tooltip", p: { html: true } },
    { type: "string", id: "style", role: "style" },
    { type: "date", id: "Start" },
    { type: "date", id: "End" },
  ],
];

const TimelineAdo: React.FC<TimelineAdoProps> = ({
  items,
  showChartMenu,
  setShowChartMenu,
  viewId,
  onSetRefresh,
  onUpdateTicket,
  onMoveAndExtendIteration,
  RemoveFromTimeline,
  AddPlanningTask,
  createTicket,
  FindTicket,
  AddTicketToSprint,
  project,
  teamId,
  assigneeId,
  selectedPriorityDriver,
  selectedTags,
  selectedAreaPath,
  quarterFilter,
  showTeams, // Default to false if not provided
  useAdvancedMode, // Pass useAdvancedMode
  projectWorkItemData,
  usersData,
  capexOptions,
  govProjectOptions,
  priorityDriverOptions,
  demoOptions,
  productOptions,
  investmentClassOptions,
  areaPathOptions,
  azureDevOpsService,
  iterationsData,
  multiSelectMode,
  onMultiSelectChange,
}) => {

  const [selectedTicket, setSelectedTicket] = useState<Ticket | null>(null);
  const [selectedTickets, setSelectedTickets] = useState<Ticket[]>([]);
  const [showMultiSelectMenu, setShowMultiSelectMenu] = useState<boolean>(false);

  const handleEditMultiSelect = () => {
    if (selectedTickets.length > 0) {
      setShowMultiSelectMenu(true);
    }
  };
  const [selectedSprint, setSelectedSprint] = useState<SelectedSprint | null>(null);
  const [showSprintHeaderChartMenu, setShowSprintHeaderChartMenu] = useState<boolean>(false);


  /****************************************/
  const openOnClickStatus = false;
  const chartHeight = 1500;
  /****************************************/

  let dataArray: any[][] = [];

  dataArray = dataArray.concat(arraySetup);

  let data : TimelineDataResult = new TimelineDataResult()



  data = PrepareTimelineDataAdoSimplified(items, teamId, selectedPriorityDriver, assigneeId, viewId, quarterFilter, selectedTags, selectedAreaPath);
  const _iterationHeader = iterationHeader(data.minDate ?? new Date(0), data.maxDate ?? new Date(0));
  dataArray = dataArray.concat(createQuarterHeader(_iterationHeader));
  dataArray = dataArray.concat(_iterationHeader);
  dataArray = dataArray.concat(data.dataset);
  dataArray = dataArray.filter((item) => (item[4] && item[5]) ); // Filter out empty rows

  if (data?.dataset?.length > 0) {
    return (
      <>
        {/* TODO: ChartMenuAdo expects onSelectChart, chartTypes, selectedChart. Update usage as needed. */}

        <ChartMenu
          showChartMenu={showChartMenu}

          selectedTicket={selectedTicket}
          menuTicketID={selectedTicket ? selectedTicket.id.toString() : ""}
          onSetRefresh={onSetRefresh}
          handleClose={function (): void {
            setShowChartMenu(false);
          } }
          onUpdateTicket={onUpdateTicket}
          onMoveAndExtendIteration={onMoveAndExtendIteration}
          RemoveFromTimeline ={ RemoveFromTimeline}
          AddPlanningTask = {AddPlanningTask}
          showTeams={showTeams}
          useAdvancedMode={useAdvancedMode} // Pass useAdvancedMode
          createTicket={createTicket}
          projectWorkItemData={projectWorkItemData}
          usersData={usersData}
          capexOptions={capexOptions}
          govProjectOptions={govProjectOptions}
          priorityDriverOptions={priorityDriverOptions}
          demoOptions={demoOptions}
          productOptions={productOptions}
          investmentClassOptions={investmentClassOptions}
          areaPathOptions={areaPathOptions}
          azureDevOpsService={azureDevOpsService}
          iterationsData={iterationsData}
          selectedAreaPath={selectedAreaPath}
          onSelectTicket={(ticket: Ticket) => {
            setSelectedTicket(ticket);
          }}
        />

        <ChartMenuMultiSelect
          showMultiSelectMenu={showMultiSelectMenu}
          selectedTickets={selectedTickets}
          onSetRefresh={onSetRefresh}
          handleClose={() => {
            setShowMultiSelectMenu(false);
            setSelectedTickets([]);
            if (onMultiSelectChange) {
              onMultiSelectChange(0, handleEditMultiSelect);
            }
          }}
          onMoveAndExtendIteration={onMoveAndExtendIteration}
          RemoveFromTimeline={RemoveFromTimeline}
          onUpdateTicket={onUpdateTicket}
        />

        <ChartSprintHeaderMenuAdo
          showSprintHeaderChartMenu={showSprintHeaderChartMenu && !showChartMenu}
          selectedSprint={selectedSprint}
          project={project}
          onSetRefresh={onSetRefresh}
          handleClose={() => {setShowSprintHeaderChartMenu(false)}}
          FindTicket={FindTicket}
          AddTicketToSprint={AddTicketToSprint}
          createTicket={createTicket}
          selectedAreaPath={selectedAreaPath}
        />

        {/* TODO: Implement ChartSprintHeaderMenuAdo as a React component and use here. */}
        {/* <ChartSprintHeaderMenuAdo ...props /> */}
        <Chart
          width={"99%"}
          chartType="Timeline"
          options={{ height: chartHeight, avoidOverlappingGridLines: true }}
          data={dataArray}
          chartEvents={[
            {
              eventName: "select",
              callback: ({ chartWrapper, eventArgs }: any) => {
                const chart = chartWrapper.getChart();
                const selection = chart.getSelection();
                if (selection.length === 1) {
                  const [selectedItem] = selection;
                  const dataTable = chartWrapper.getDataTable();
                  const { row } = selectedItem;
                  const title = dataTable.getValue(row, 1);
                  const ticketId = title.substring(title.indexOf("[") + 1, title.indexOf("]"));
                  const regexp = new RegExp("^[2][0-9]T[0-9]{1,2}$");
                  const sprintId = regexp.exec(title);

                  if (ticketId !== "" && !sprintId) {
                    const _selectedTicket = items.find(item => item.id.toString() === ticketId);

                    if (multiSelectMode && _selectedTicket) {
                      setSelectedTickets(prev => {
                        const isAlreadySelected = prev.some(ticket => ticket.id.toString() === ticketId);
                        let newSelection;
                        if (isAlreadySelected) {
                          newSelection = prev.filter(ticket => ticket.id.toString() !== ticketId);
                        } else {
                          newSelection = [...prev, _selectedTicket];
                        }

                        if (onMultiSelectChange) {
                          setTimeout(() => onMultiSelectChange(newSelection.length, handleEditMultiSelect), 0);
                        }

                        return newSelection;
                      });
                      setSelectedTicket(null);
                      setShowChartMenu(false);

                      TelemetryService.trackUserAction('Timeline_TicketSelected', {
                        ticketId,
                        viewId,
                        selectedPriorityDriver,
                        teamId,
                        project,
                        isMultiSelect: true
                      });
                    } else if (!multiSelectMode && _selectedTicket) {
                      setSelectedTickets([]);
                      setShowMultiSelectMenu(false);

                      TelemetryService.trackUserAction('Timeline_TicketSelected', {
                        ticketId,
                        viewId,
                        selectedPriorityDriver,
                        teamId,
                        project,
                        isMultiSelect: false
                      });

                      if (openOnClickStatus) {
                        const url = tConst.AZURE_DEVOPS_BASE_TICKET_URI + (ticketId ? ticketId : "");
                        window.open(url, "_blank");
                        TelemetryService.trackUserAction('Timeline_TicketOpenedInNewTab', { ticketId, url });
                      } else {
                        setSelectedTicket(_selectedTicket);
                        setShowChartMenu(true);
                        TelemetryService.trackUserAction('Timeline_ChartMenuOpened', { ticketId });
                      }
                    }
                  }
                  else if (sprintId !== null) {
                    TelemetryService.trackUserAction('Timeline_SprintSelected', {
                      sprintId: sprintId[0],
                      viewId,
                      teamId,
                      project
                    });

                    const ToolTip = dataTable.getValue(row, 2)
                    const period = new RegExp("Period: [0-9]{1,2}\\. \\w{3} [0-9]{4} - [0-9]{1,2}\\. \\w{3} [0-9]{4}").exec(ToolTip);
                    const sDateMatch = period ? new RegExp("[0-9]{1,2}\\. \\w{3} [0-9]{4}").exec(period[0]) : null;
                    const eDateMatch = period ? new RegExp("[0-9]{1,2}\\. \\w{3} [0-9]{4}$").exec(period[0]) : null;
                    const sDate = sDateMatch ? sDateMatch[0] : "";
                    const eDate = eDateMatch ? eDateMatch[0] : "";
                    const _sDate = new Date (new Date(sDate).setHours(16, 0, 0, 0));
                    const _eDate = new Date (new Date(eDate).setHours(4,0,0,0));

                    const _selSprint : SelectedSprint = new SelectedSprint( sprintId ? sprintId[0] : "", _sDate, _eDate )
                    setSelectedSprint(_selSprint);
                    setShowChartMenu(false);
                    setShowMultiSelectMenu(false);
                    setSelectedTickets([]);
                    setShowSprintHeaderChartMenu(true);
                  }
                }
              },
            },
          ]}
        />
      </>
    );
  } else {
    return (
      <>
        <br />
        <Button type="primary">Add ticket to timeline</Button>
      </>
    );
  }
};

export default TimelineAdo;
